<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout>
      <v-flex text-xs-center>
        <SvgButtons @openModal="modal=true, text=$event, $set(vistos,$event,true)"/>
      </v-flex>
    </v-layout>
    <modal-app v-model="modal" :fullscreen="false" width="700px">
      <h1 class="modal-title">{{modalTitle}}</h1>
      <p>{{modalText}}</p>
    </modal-app>

    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 2/AUDIO 03'
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgButtons from '../../assets/Modulo 2/diapositiva-3'
export default {
  components:{
    SvgButtons
  },
  data() {
    return {
      dialogos: [
        "Veamos el siguiente esquema para la clasificación según SPE – PRMS. <span class='instruccion'>Haz clic en los iconos para conocer más.</span>" 
      ],
      text: 0,
      modal: false,
      vistos: Array(3).fill(false)
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  computed: {
    modalTitle: function(){
      switch(this.text){
        case 0: return 'Petróleo total'
        case 1: return 'Petróleo no descubierto inicialmente en sitio'
        case 2: return 'Petróleo descubierto inicialmente en sitio'
      }
    },
    modalText: function(){
      switch(this.text){
        case 0: return 'Es la cantidad total de petróleo que se estima existe originalmente en las acumulaciones con las que se cuenta; incluye todos los hidrocarburos en su fase líquida, gaseosa y sólida antes de haber sido producidos. Incluye las acumulaciones descubiertas y las no descubiertas.'
        case 1: return 'Es la cantidad de petróleo estimada a una fecha determinada contenida en acumulaciones que aún no han sido descubiertas.'
        case 2: return 'Es aquella cantidad de petróleo estimada a una fecha determinada, contenida en acumulaciones conocidas antes de la puesta en producción. Existen dos categorías para esta clasificación: comercial y subcomercial.'
      }
    }
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos){
        this.$store.commit('nextShow', true)    
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
